import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseUnpaidAmountReminderTemplates = [
  {
    id: '-127001',
    language: Language.EN,
    subject: 'Reminder 1: Unpaid amount',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: unpaid amount related to the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if isPartiallyPaid}}
        <p>Unless we are mistaken, {{getInvoiceOrPaymentRequest lease}} number {{invoice.invoiceNumber}}, issued on {{formatDate invoice.invoiceDate}} and due on {{formatDate invoice.dueDate}}, remains <strong>partially unpaid</strong>.</p>
        <p>Initial amount of the {{getInvoiceOrPaymentRequest lease}}: <strong>{{amountTotal}} €</strong><br>Amount already paid: <strong>{{amountPaid}} €</strong></p>
        <p>Remaining balance due: <strong>{{totalAmount}} €</strong></p>
        <p>We kindly ask you to proceed to the payment of the remaining balance as soon as possible:</p>
        {{else}}
        <p>Unless we are mistaken, {{getInvoiceOrPaymentRequest lease}} number {{invoice.invoiceNumber}} of an amount of <strong>{{totalAmount}} €</strong> issued on {{formatDate invoice.invoiceDate}} and due on {{formatDate invoice.dueDate}} remains unpaid.</p>
        <p>We kindly ask you to proceed to the payment of the latter as soon as possible:</p>
        {{/if}}
        <ul><li>Account number held by {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Amount: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Remittance information: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Please find a copy of the {{getInvoiceOrPaymentRequest lease}} attached.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-127002',
    language: Language.FR,
    subject: 'Rappel 1: Montant impayé',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: montant impayé relatif au bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if isPartiallyPaid}}
        <p>Sauf erreur de notre part, la {{getInvoiceOrPaymentRequest lease}} numéro {{invoice.invoiceNumber}}, émise le {{formatDate invoice.invoiceDate}} et due pour le {{formatDate invoice.dueDate}}, reste <strong>partiellement impayée</strong>.</p>
        <p>Montant initial de la {{getInvoiceOrPaymentRequest lease}} : <strong>{{amountTotal}} €</strong><br>Montant déjà payé : <strong>{{amountPaid}} €</strong></p>
        <p>Solde restant dû : <strong>{{totalAmount}} €</strong></p>
        <p>Nous vous prions de bien vouloir procéder au paiement du solde restant dû le plus rapidement possible:</p>
        {{else}}
        <p>Sauf erreur de notre part, la {{getInvoiceOrPaymentRequest lease}} numéro {{invoice.invoiceNumber}} d'un montant de <strong>{{totalAmount}} €</strong> émise le {{formatDate invoice.invoiceDate}} et due pour le {{formatDate invoice.dueDate}} demeure impayée.</p>
        <p>Nous vous prions de bien vouloir procéder au paiement de cette dernière le plus rapidement possible:</p>
        {{/if}}
        <ul><li>Numéro de compte au nom de {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Montant: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Communication: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Veuillez trouver une copie de la {{getInvoiceOrPaymentRequest lease}} en pièce jointe.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-127003',
    language: Language.NL,
    subject: 'Herinnering 1: Onbetaald bedrag',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: onbetaald bedrag met betrekking tot het huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if isPartiallyPaid}}
        <p>Tenzij wij ons vergissen, is {{getInvoiceOrPaymentRequest lease}} nummer {{invoice.invoiceNumber}}, opgesteld op {{formatDate invoice.invoiceDate}} en verschuldigd op {{formatDate invoice.dueDate}}, <strong>gedeeltelijk onbetaald</strong> gebleven.</p>
        <p>Oorspronkelijk bedrag van de {{getInvoiceOrPaymentRequest lease}}: <strong>{{amountTotal}} €</strong><br>Reeds betaald bedrag: <strong>{{amountPaid}} €</strong></p>
        <p>Resterend verschuldigd saldo: <strong>{{totalAmount}} €</strong></p>
        <p>Wij verzoeken u vriendelijk zo spoedig mogelijk het resterende saldo te betalen:</p>
        {{else}}
        <p>Tenzij wij ons vergissen, is {{getInvoiceOrPaymentRequest lease}} nummer {{invoice.invoiceNumber}} ten bedrage van <strong>{{totalAmount}} €</strong> opgesteld op {{formatDate invoice.invoiceDate}} en verschuldigd op {{formatDate invoice.dueDate}} blijft onbetaald.</p>
        <p>Wij verzoeken u vriendelijk zo spoedig mogelijk tot betaling van dit laatste over te gaan:</p>
        {{/if}}
        <ul><li>Rekeningnummer bij {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Bedrag: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Mededeling: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Gelieve een copie van ons {{getInvoiceOrPaymentRequest lease}} bijgevoegd te vinden.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
      `,
  },
  {
    id: '-127004',
    language: Language.DE,
    subject: 'Erinnerung 1: Unbezahlter Betrag',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Sehr geehrte/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Unbezahlter Betrag im Zusammenhang mit dem Mietvertrag für die Immobilie in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if isPartiallyPaid}}
        <p>Soweit wir nicht irren, ist die {{getInvoiceOrPaymentRequest lease}} Nummer {{invoice.invoiceNumber}}, ausgestellt am {{formatDate invoice.invoiceDate}} und fällig am {{formatDate invoice.dueDate}}, <strong>teilweise unbezahlt</strong> geblieben.</p>
        <p>Ursprünglicher Betrag der {{getInvoiceOrPaymentRequest lease}}: <strong>{{amountTotal}} €</strong><br>Bereits bezahlter Betrag: <strong>{{amountPaid}} €</strong></p>
        <p>Verbleibendes Restguthaben: <strong>{{totalAmount}} €</strong></p>
        <p>Wir bitten Sie freundlich, den verbleibenden Restbetrag baldmöglichst zu begleichen:</p>
        {{else}}
        <p>Soweit wir nicht irren, bleibt die {{getInvoiceOrPaymentRequest lease}} Nummer {{invoice.invoiceNumber}} in Höhe von <strong>{{totalAmount}} €</strong>, ausgestellt am {{formatDate invoice.invoiceDate}} und fällig am {{formatDate invoice.dueDate}}, unbezahlt.</p>
        <p>Wir bitten Sie freundlich, diese baldmöglichst zu begleichen:</p>
        {{/if}}
        <ul><li>Kontonummer bei {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Betrag: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Verwendungszweck: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Im Anhang finden Sie eine Kopie der {{getInvoiceOrPaymentRequest lease}}.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
